import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

function PrivacyPolicy() {
  return (
    <Container fluid className="about-section policy-page">
      <Particle />
      <Container className="policy-container">
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <header className="policy-header">
              <h1 className="policy-title">
                <span className="purple">Privacy Policy</span>
              </h1>
              <p className="policy-lead">Choicest Fruit®, LLC</p>
              <p className="policy-lead">Effective Date: April 23, 2026</p>
              <p className="policy-lead">Last Updated: April 23, 2026</p>
            </header>

            <section className="policy-card" aria-label="Privacy Policy">
              <nav className="policy-toc" aria-label="On this page">
                <div className="policy-toc-title">On this page</div>
                <ul className="policy-toc-list">
                  <li>
                    <a className="policy-toc-link" href="#privacy-introduction">
                      1. Introduction
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-info-collected">
                      2. Information We Collect
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-use">
                      3. How We Use Your Information
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-sharing">
                      4. Sharing of Information
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-cookies">
                      5. Cookies and Tracking Technologies
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-security">
                      6. Data Security
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-children">
                      7. Children’s Privacy
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-third-party-links">
                      8. Third-Party Links
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-rights">
                      9. Your Rights and Choices
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-updates">
                      10. Updates to This Policy
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#privacy-contact">
                      11. Contact Us
                    </a>
                  </li>
                </ul>
              </nav>

              <h2 id="privacy-introduction" className="policy-section-title">1. Introduction</h2>
              <p className="policy-text">
                Choicest Fruit®, LLC (“Choicest Fruit,” “we,” “our,” or “us”) is committed to protecting your
                privacy. This Privacy Policy explains how we collect, use, and safeguard your information when
                you visit our website, participate in our programs, use our services, or engage with platforms
                we support, including Favrhood.
              </p>
              <p className="policy-text">
                By using our website or services, you agree to the terms of this Privacy Policy.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-info-collected" className="policy-section-title">2. Information We Collect</h2>
              <p className="policy-text">We may collect the following types of information:</p>

              <h3 className="policy-subtitle">a. Personal Information</h3>
              <ul className="policy-list">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Organization or school affiliation</li>
                <li>Any information you provide through forms, applications, or program participation</li>
              </ul>

              <h3 className="policy-subtitle">b. Usage Information</h3>
              <ul className="policy-list">
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device information</li>
                <li>Pages visited and time spent on the site</li>
              </ul>

              <h3 className="policy-subtitle">c. Program &amp; Participation Information</h3>
              <p className="policy-text">
                If you participate in our programs (e.g., internships, workshops), we may collect:
              </p>
              <ul className="policy-list">
                <li>Application details</li>
                <li>Project submissions</li>
                <li>Feedback, reflections, and assessments</li>
              </ul>

              <div className="policy-divider" />

              <h2 id="privacy-use" className="policy-section-title">3. How We Use Your Information</h2>
              <p className="policy-text">We use your information to:</p>
              <ul className="policy-list">
                <li>Provide and manage programs, services, and events</li>
                <li>Respond to inquiries and communicate with you</li>
                <li>Improve our website, programs, and user experience</li>
                <li>Evaluate program outcomes and impact</li>
                <li>
                  Share updates, opportunities, or relevant information (you may opt out at any time)
                </li>
              </ul>

              <div className="policy-divider" />

              <h2 id="privacy-sharing" className="policy-section-title">4. Sharing of Information</h2>
              <p className="policy-text">We do not sell your personal information.</p>
              <p className="policy-text">We may share information:</p>
              <ul className="policy-list">
                <li>
                  With trusted partners or service providers who help operate our programs or website
                </li>
                <li>When required by law or to comply with legal obligations</li>
                <li>
                  With your consent (for example, showcasing projects or testimonials)
                </li>
              </ul>

              <div className="policy-divider" />

              <h2 id="privacy-cookies" className="policy-section-title">5. Cookies and Tracking Technologies</h2>
              <p className="policy-text">
                Our website may use cookies or similar technologies to:
              </p>
              <ul className="policy-list">
                <li>Improve user experience</li>
                <li>Understand how visitors use our site</li>
              </ul>
              <p className="policy-text">
                You can adjust your browser settings to disable cookies if you prefer.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-security" className="policy-section-title">6. Data Security</h2>
              <p className="policy-text">
                We take reasonable measures to protect your information from unauthorized access, loss, or
                misuse. However, no method of transmission over the internet is 100% secure.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-children" className="policy-section-title">7. Children’s Privacy</h2>
              <p className="policy-text">
                Some of our programs serve youth. We take care to protect children’s information and collect
                personal data from minors only with appropriate consent from a parent, guardian, or
                participating organization, where required.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-third-party-links" className="policy-section-title">8. Third-Party Links</h2>
              <p className="policy-text">
                Our website may include links to third-party websites or platforms (including Favrhood or
                partner sites). We are not responsible for the privacy practices of those external sites.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-rights" className="policy-section-title">9. Your Rights and Choices</h2>
              <p className="policy-text">You may:</p>
              <ul className="policy-list">
                <li>Request access to your personal information</li>
                <li>Request corrections or updates</li>
                <li>Request that we delete your information (where applicable)</li>
                <li>Opt out of communications at any time</li>
              </ul>
              <p className="policy-text">
                To make a request, contact us at the email below.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-updates" className="policy-section-title">10. Updates to This Policy</h2>
              <p className="policy-text">
                We may update this Privacy Policy from time to time. Changes will be posted on this page with
                an updated effective date.
              </p>

              <div className="policy-divider" />

              <h2 id="privacy-contact" className="policy-section-title">11. Contact Us</h2>
              <p className="policy-text">
                If you have questions about this Privacy Policy, please contact us:
              </p>

              <address className="policy-address">
                <div className="policy-address-title">Choicest Fruit®, LLC</div>
                <div>
                  Email:{" "}
                  <a className="policy-link" href="mailto:info@choicestfruit.com">
                    info@choicestfruit.com
                  </a>
                </div>
                <div>Location: Austin, Texas</div>
              </address>
            </section>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default PrivacyPolicy;
